import { findIndex, replaceElement } from "@fluentui/react/lib/Utilities";

export function replaceElementInControlArray<T extends { id?: string }>(
  controls: T[],
  controlId: string,
  transformationFunction: (props: T, ...args: any[]) => T,
  ...args: any[]
): T[] {
  const controlIndex = findIndex(
    controls,
    (props: T) => props.id === controlId
  );
  if (controlIndex !== -1) {
    const newControl = transformationFunction(controls[controlIndex], ...args);

    return replaceElement(controls, newControl, controlIndex);
  }
  return controls;
}
